/**
 * Dispatch MFE event to other MFEs
 * https://web.tui/resources/specification/
 * @param eventName
 * @param data
 */
export const dispatchMFEEvent = (eventName, data) => {
  document.dispatchEvent(
    new CustomEvent(eventName, {
      detail: {
        name: eventName,
        origin: 'tui-payments',
        id: window.tuiPaymentsMFEInstance?.id || null,
        variant: null,
        category: null,
        data,
      },
    }),
  )
}

/**
 * Dispatch MFE event to Adobe Analytics
 * https://web.tui/articles/best-practices/ 2.7 point
 * @param eventName
 */

let AdobeEvent = null

export const dispatchMFEAdobeEvent = eventName => {
  if (AdobeEvent === eventName) return
  AdobeEvent = eventName

  document.dispatchEvent(
    new CustomEvent('openmfe.analytics', {
      detail: {
        origin: 'Payments-MFE',
        name: eventName,
        id: 'Payments-MFE',
        category: 'Payments-MFE',
        data: {
          eventLabel: eventName,
        },
      },
      bubbles: true,
      composed: true,
    }),
  )

  // debounce the same events
  setTimeout(() => {
    AdobeEvent = null
  }, 300)
}

export const dispatchPaymentDetailsIframeEvent = (data, iframeWindow) => {
  if (!iframeWindow) return
  iframeWindow.postMessage(data, '*')
}

/**
 * Dispatch a same-window pay-request event so the active card form can
 * trigger its own validation before submission.
 * Same-window only (no cross-origin postMessage), carries no data payload.
 */
export const dispatchPayRequest = () =>
  window.dispatchEvent(new Event('opp-pay-request'))
